import * as React from "react";
import type { SVGProps } from "react";
const SvgCalculator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <rect
      width={15}
      height={15}
      x={2.5}
      y={2.5}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      rx={2.5}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 2.5v15M5 6.25h2.5M6.25 7.5V5M5 13.75h2.5M12.5 8.75H15M12.5 11.25H15M2.5 10H10"
    />
  </svg>
);
export default SvgCalculator;
